/**
 *  Vip 充值面板
 */

import './VipRechargeModal.css';
import { useContext, useEffect, useState } from "react";
import { Button, message, Modal } from "antd";
import { Order, Product, Subscription } from "@/common/constants/interfaces";
import eventBus from "@/common/services/eventBus";
import { request } from "@/common/utils/utils";
import URLS from "@/common/constants/url";
import ProductCard from "./ProductCard/ProductCard";
import CustomEvents from '@/common/constants/customEvents';
import { PaymentStatus } from '@/common/constants/interfaces';
import { FileCenterContext, IFileCenterContext } from '@/common/components/FileCenterProvider';
import { reportCheckPayFailed, reportClickPayBtn, reportCreateOrderFailed, reportCreateOrderSuccess, reportOpenVipPanel } from '@/common/utils/report';

interface PayResonseData {
    payPage: string;
    order: Order;
}

let payPage: string;

function VipRechargeModal() {
    const { userInfo, setSubscription } = useContext<IFileCenterContext>(FileCenterContext);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [products, setProducts] = useState<Product[]>([])
    const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
    const [isPayPage, setIsPayPage] = useState<boolean>(false)
    const [polling, setPolling] = useState<NodeJS.Timeout | null>(null);

    const handleProductCardSelect = (producd: Product) => {
        setSelectedProduct(producd);
    };

    useEffect(() => {
        const fetchProducts = async () => {
            const data = await request<Product[]>({ url: URLS.GET_PRODUCTS_PATH, method: 'GET' })
            setProducts(data)
            setSelectedProduct(data[0])
        }
        fetchProducts()
    }, [])


    useEffect(() => {
        eventBus.on(CustomEvents.OPEN_VIP_PANEL, () => {
            setIsModalOpen(true);
            reportOpenVipPanel();
        })

        return () => {
            eventBus.off(CustomEvents.OPEN_VIP_PANEL, () => {
                setIsModalOpen(false);
            })
        }
    }, [])

    useEffect(() => {
        return () => {
            if (polling) {
                clearInterval(polling);
            }
        };
    }, [polling]);

    // 轮询检查扫码状态
    const startPolling = (orderNumber: string) => {
        if (!userInfo) {
            return;
        }
        const timer = setInterval(async () => {
            try {
                // 这里需要替换为你的后端API
                const data = await request<Order>({ url: URLS.GET_ORDER_PATH, method: 'GET', params: { order_number: orderNumber } });
                if (data.payment_status === PaymentStatus.TRADE_SUCCESS || data.payment_status === PaymentStatus.TRADE_FINISHED) {
                    clearInterval(timer);
                    const data2 = await request<Subscription>({ url: URLS.GET_LATEST_SUBSCRIPTION_PATH, method: 'GET' })
                    setSubscription(data2);
                    setIsModalOpen(false);
                }
            } catch (error) {
                clearInterval(timer);
                message.error('检查订单支付状态失败,请点击页面【人工客服】，我们会马上处理');
                reportCheckPayFailed(orderNumber, error + '');
            }
        }, 1000);
        setPolling(timer);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setIsPayPage(false);
        if (polling) {
            clearInterval(polling);
        }
    }

    const handleClick = async () => {
        if (!userInfo || !selectedProduct) {
            return;
        }
        reportClickPayBtn(selectedProduct.id)

        try {
            const data = await request<PayResonseData>({ url: URLS.CREATE_ORDER_PATH, method: 'GET', params: { productId: selectedProduct.id } })
            payPage = `<!DOCTYPE html><html><body><h1>支付页面内容</h1>${data.payPage}</body></html>`
            setIsPayPage(true)
            startPolling(data.order.order_number)
            reportCreateOrderSuccess(selectedProduct.id);
        } catch (error) {
            message.error('创建订单失败,请点击页面【人工客服】，我们会马上处理');
            reportCreateOrderFailed(selectedProduct.id, error + '');
        }

    }

    const handleReturnProductPage = () => {
        setIsPayPage(false)
    }

    const footer = isPayPage ? (
        [
            <Button key="back" onClick={handleReturnProductPage}>
                返回
            </Button>,
            <Button key="submit" type="primary" onClick={handleModalClose}>
                取消
            </Button>
        ]
    ) : (
        <Button type="primary" onClick={handleClick}>立即支付</Button>
    )

    return (
        <Modal
            title="叮当AI助手会员"
            open={isModalOpen}
            onCancel={handleModalClose}
            className="user-feedback-modal"
            footer={footer}
        >
            {!isPayPage && (
                <div>
                    <div className="product-container">
                        {
                            products.map(p => (<ProductCard key={p.id} product={p} selected={selectedProduct?.id === p.id} onSelect={handleProductCardSelect} />))
                        }
                    </div>
                    <div className='total-price'>￥{selectedProduct?.price}</div>
                </div>
            )}
            {isPayPage && (
                <iframe srcDoc={payPage} className='pay-page-iframe' title="payPage" />
            )}
        </Modal>
    );
}

export default VipRechargeModal;